import React, { Component } from "react"

import {
    Container,
    Card,
    CardBody,
    Button
} from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

import { ROUTER_GROUP } from "helpers/router_helper"
import { VIEW_GROUP_NGO } from "helpers/view_helper"

class BirthDetailsLandingPage extends Component {
    constructor(props) {
        super(props)
    }

    renderSuccess = () => {
        let groupType = "none"
        let generateReportpage = "generate-report";

        if (sessionStorage.getItem("groupType")) {
            console.log("sessionStorage.getItem(groupType)->groupType, ", sessionStorage.getItem("groupType"))
            groupType = JSON.parse(sessionStorage.getItem("groupType"));
            console.log("groupType before parse, ", groupType)
            groupType = JSON.parse(sessionStorage.getItem("groupType")).groupType;
            console.log("groupType after parse, ", groupType)
        }

        if (VIEW_GROUP_NGO == groupType) {
            generateReportpage = "generate-report/NGO"
        }

        if (this.props.location.success) {
            let id = this.props.location.id
            return (
                <Card>
                    <CardBody>
                        <div className="text-center">
                            <div className="avatar-md mx-auto">
                                <div className="avatar-title rounded-circle bg-success">
                                    <i className="bx bx-check h1 mb-0 text-light"></i>
                                </div>
                            </div>
                            <div className="p-2 mt-4">
                                <h4 className="">
                                    Thank you!
                                </h4>
                                <p>
                                    Your report has been generated successfully
                                </p>
                            </div>
                            <Button
                                type="button"
                                color="success"
                                className="btn waves-effect waves-light mt-2 me-1"
                                onClick={() => {
                                    this.props.history.push({
                                        pathname: `${ROUTER_GROUP}/report-summary/${id}`,
                                    })
                                }}
                            >
                                <i className="bx bx-receipt me-2" /> View report
                            </Button>
                            <Button
                                type="button"
                                color="primary"
                                className="ml-1 btn waves-effect  mt-2 waves-light"
                                onClick={() => {
                                    this.props.history.push({
                                        pathname: `${ROUTER_GROUP}/${generateReportpage}`,
                                    })
                                }}
                            >
                                <i className="bx bx-arrow-back me-2" />
                                Back to generate report
                            </Button>
                        </div>
                    </CardBody>
                </Card>
            )
        }
        return
    }

    renderFail = () => {
        if (this.props.location.fail) {
            return (
                <Card>
                    <CardBody>
                        <div className="text-center">
                            <div className="avatar-md mx-auto">
                                <div className="avatar-title rounded-circle bg-danger">
                                    <i className="bx bx-x h1 mb-0 text-light"></i>
                                </div>
                            </div>
                            <div className="p-2 mt-4">
                                <h4 className="">
                                    Failed!
                                </h4>
                                <p>
                                    Your report generation has been  failed, please contact kattam support.
                                </p>
                            </div>
                            <Button
                                type="button"
                                color="primary"
                                className="ml-1 btn waves-effect  mt-2 waves-light"
                                onClick={() => {
                                    this.props.history.push({
                                        pathname: `${ROUTER_GROUP}/generate-report`,
                                    })
                                }}
                            >
                                <i className="bx bx-arrow-back me-2" />
                                Back to generate report
                            </Button>
                        </div>
                    </CardBody>
                </Card>
            )
        }
        return
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="" breadcrumbItem="Generate AI Report" />
                        <div className="text-center">
                            {this.renderSuccess()}
                            {this.renderFail()}
                        </div>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}

export default BirthDetailsLandingPage
